import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();

// The origin used for Stripe redirect URLs. On web this follows wherever the
// user actually is (custom domain, web.app, localhost), so nothing is hardcoded.
// The native app has no usable web origin (capacitor://localhost), so it uses the
// per-environment web origin baked at build time; the server validates it.
export function webOrigin(): string {
  if (isNative) {
    const origin = import.meta.env.VITE_WEB_ORIGIN;
    if (!origin) throw new Error('VITE_WEB_ORIGIN must be set for native builds (Stripe return host).');
    return origin;
  }
  return window.location.origin;
}
